import { getEnv } from "./getEnv";

export const CORE_BFF_BASE_URL = `${getEnv().API_BASE_URL}/st/platform/core/services`;
